import React from 'react'
import PropTypes from 'prop-types'
import { Trans, useTranslation } from 'react-i18next'
import { getVerticalUrl } from 'lib/utils/store/vehicle'
import { getLocale } from 'lib/utils/getLocale'

import ErrorMessageContent from './ErrorMessageContent'
import TranslatedAppError from 'components/Errors/TranslatedAppError'
import Link from 'components/Link'
import Icon from 'components/Icon'

import './trafi-error-message.pcss'

const TrafiErrorMessage = ({ appError }) => {
    const { t, i18n } = useTranslation(['errors', 'vehicles'])

    const message = () => {
        // Our custom error codes
        if (appError.code >= 10000 && appError.code !== 10037) {
            return (
                <TranslatedAppError appError={appError}>
                    Please try again later or contact <Link to={`${getLocale(i18n.language)}/ota-yhteytta`} trackName="customerService">Customer Service</Link> if problem keeps to occure.
                </TranslatedAppError>
            )
        }

        if (appError.code === 10037) {
            return (
                <div className="trafi-error-message">
                    <p>
                        <Trans i18nKey="errors:omanettix.10037.message">
                            Selling the boat in OmaNettix service with eletric Bill of sale is not possible yet, but we are working on it.
                        </Trans>
                    </p>
                    <div>
                        <div className="trafi-error-message__pdf-info">
                            {t('errors:omanettix.10037.salesPdf')}
                        </div>
                        <ul className="trafi-error-message__pdf-list error-actions">
                            <li>
                                <Icon name="icon_pdf" size="m" />
                                <Link
                                    to={`${getVerticalUrl(t, 'boat')}/kauppakirja`}
                                    trackLabel="boat"
                                    trackName="bosPDF"
                                >{t('vehicles:vertical.boat.salesPdf')}
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            )
        }

        return (
            <div className="trafi-error-message">
                <p>
                    <Trans i18nKey="errors:errorMessage.trafiGenericRestriction.hasTrafiErrorCode">
                        Service wasn&apos;t able to get vehicle details from Trafi. If register number you entered is correct, this could be just temporary connection failure. Please try again later or contact <Link to={`${getLocale(i18n.language)}/ota-yhteytta`} trackName="customerService">Customer Service</Link> if problem keeps to occure.
                    </Trans>
                </p>
                <div>
                    <div className="trafi-error-message__pdf-info">
                        {t('errors:errorMessage.trafiGenericRestriction.salesPdf')}
                    </div>
                    <ul className="trafi-error-message__pdf-list error-actions">
                        <li>
                            <Icon name="icon_pdf" size="m" />
                            <Link
                                to={`${getVerticalUrl(t, 'car')}/kauppakirja`}
                                trackLabel="car"
                                trackName="bosPDF"
                            >{t('vehicles:vertical.car.salesPdf')}
                            </Link>
                        </li>
                        <li>
                            <Icon name="icon_pdf" size="m" />
                            <Link
                                to={`${getVerticalUrl(t, 'boat')}/kauppakirja`}
                                trackLabel="boat"
                                trackName="bosPDF"
                            >
                                {t('vehicles:vertical.boat.salesPdf')}
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        )
    }

    return (
        <ErrorMessageContent
            content={message()}
        />
    )
}

export default TrafiErrorMessage

TrafiErrorMessage.propTypes = {
    appError: PropTypes.object.isRequired,
}
